<template>
  <div class="container">
    <QueryFrame
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      ref="queryFrame"
      :count='count'
      :current="page"
    >
      <div slot="queryParams" class="form">
        <div class="queryContainer">
          <div class="queryItem" v-if="query.endStatus==approvalTabStatus.RELATED">
            <label>审批类型:</label>
            <lk-select class="item" filterable clearable v-model.trim='query.businessType'>
              <lk-option v-for="item in relatedBussinessTypes" :key="item.id" :value="item.businessType">{{item.name}}</lk-option>
            </lk-select>
          </div>
           <div class="queryItem" v-else>
            <label>审批类型:</label>
            <lk-select class="item" filterable clearable v-model.trim='query.businessType'>
              <lk-option v-for="item in bussinessTypes" :key="item.id" :value="item.businessType">{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem" v-if="this.roleType !== 2">
            <label>门店名称:</label>
            <StoreListSelect class="item" clearable v-model.trim='query.storeIdList'></StoreListSelect>
          </div>
          <div class="queryItem"  v-if="query.endStatus==approvalTabStatus.RELATED">
            <label>创建时间:</label>
              <timeStampDatePicker class="item" type='daterange' v-model="query.createTime">
            </timeStampDatePicker>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <lk-button v-if="handlePermission('workListExport')" class="export-btn" type='primary' @click="showExportModal">导出审批单</lk-button>
        <lk-tabs type="card" v-model="query.endStatus" @on-click="onTabClick">
          <lk-tab-pane label="待我审批" :name="approvalTabStatus.WAIT">
            <lk-table border :columns='waitColumns' :data='tableData' v-if="query.endStatus==approvalEndStatus.WAIT"></lk-table>
          </lk-tab-pane>
          <lk-tab-pane label="我已审批" :name="approvalTabStatus.READY">
            <lk-table border :columns='finishColumns' :data='tableData' v-if="query.endStatus==approvalEndStatus.READY"></lk-table>
          </lk-tab-pane>
          <lk-tab-pane label="我的审批" :name="approvalTabStatus.MINE">
            <lk-table border :columns='myColumns' :data='tableData' v-if="query.endStatus==approvalTabStatus.MINE"></lk-table>
          </lk-tab-pane>
          <lk-tab-pane label="相关审批" :name="approvalTabStatus.RELATED" v-if="showRelated">
            <lk-table border :columns='relatedColumns' :data='tableData' v-if="query.endStatus==approvalTabStatus.RELATED"></lk-table>
          </lk-tab-pane>
        </lk-tabs>
      </div>
    </QueryFrame>
    <lk-modal
      v-model="modalVisiable"
      :mask-closable="false"
      title="导出审批单"
      width="400"
      @on-cancel="cancelModal"
    >
      <lk-form
        :model="exportQuery"
        label-position="right"
        :label-width="80"
        ref="export"
        class="exportQueryContainer"
        :rules="exportValidate">
        <div class="export-query">
          <lk-form-item label="审批类型:" prop="workExportType" class="queryItem">
            <lk-select class="item" clearable v-model.trim="exportQuery.workExportType" placeholder="请选择">
              <lk-option v-for="item in approveTypeList" :key="item.id" :value='item.id'>
                {{item.name}}
              </lk-option>
            </lk-select>
          </lk-form-item>
          <lk-form-item label="申请门店:" prop="storeIdList" class="queryItem">
            <StoreListSelect class="item" clearable v-model.trim='exportQuery.storeIdList'></StoreListSelect>
          </lk-form-item>
          <lk-form-item label="申请日期:" prop="createTime" class="queryItem">
            <timeStampDatePicker class="item" type='daterange' v-model="exportQuery.createTime"></timeStampDatePicker>
          </lk-form-item>
        </div>
      </lk-form>
      <div slot="footer">
        <div>
          <lk-button class="mr" type='primary' @click="exportData">确认导出</lk-button>
        </div>
      </div>
    </lk-modal>
  </div>
</template>

<script>
import QueryFrame from '@/components/frame/QueryFrame.vue';
import workflow from '@/services/workflow';
import utils from '@/libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';


export default {
  name: 'WorkList',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
  },
  data() {
    return {
      bussinessTypes: [],
      showRelated: false,
      query: {
        businessType: '',
        endStatus: '2',
        createTime: [],
        storeIdList: [],
      },
      // hoverList: [
      //   'purchase_refund', 'sale_price', 'sale_refund_audit', 'sale_store_cancel', 'single_finance_payable', 'single_inspect_reject',

      // ],
      hoverList: {
        purchase_refund: '供应商名称-退货总金额-退货单号',
        sale_price: '商品通用名-规格-原价格-现价格',
        sale_price_multi: '商品通用名-规格-多价格',
        sale_refund_audit: '退货单号-退货总金额',
        sale_store_cancel: '销售单号-订单总金额',
        single_finance_payable: '应付单号-供应商名称-总金额',
        single_inspect_reject: '单号-供应商名称',
      },
      modalVisiable: false,
      approveTypeList: [
        { name: '采购计划审批导出', id: 1 },
        { name: '应收限额审批导出', id: 2 },
        { name: '首营商品审批导出', id: 3 },
        { name: '销售调价审批导出', id: 4 },
      ],
      exportQuery: {
        workExportType: null,
      },
      exportValidate: {
        workExportType: [
          {
            required: true,
            message: '请选择导出类型',
            trigger: 'change',
            type: 'number',
          },
        ],
      },
      waitColumns: [
        { title: '审批编号', key: 'workRecordWorkNo', minWidth: 280 },
        { title: '审批类型', key: 'workBizTypeName', minWidth: 140 },
        {
          title: '审批名称',
          key: 'workRecordTitle',
          minWidth: 116,
          render: this.hoverRender,
        },
        { title: '当前节点', key: 'workRecordNode', width: 90 },
        { title: '提交审批人', key: 'workRecordCreateUserName', width: 120 },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 80,
          render: (h, { row }) => h('div', {
            class: {
              textCenter: true,
            },
          }, [
            h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.approve(row, this.approvalTabStatus.WAIT);
                },
              },
            }, '去审批'),
          ]),
        },
      ],
      tableData: [],
      finishColumns: [
        { title: '审批编号', key: 'workRecordWorkNo', minWidth: 280 },
        { title: '审批类型', key: 'workBizTypeName', minWidth: 140 },
        {
          title: '审批名称',
          key: 'workRecordTitle',
          minWidth: 116,
          render: this.hoverRender,
        },
        { title: '当前节点', key: 'workRecordNode', width: 90 },
        {
          title: '业务审核内容',
          key: 'workRecordBusinessUrl',
          minWidth: 116,
          render: (h, { row }) => h('div', {
            class: {
              textCenter: true,
            },
          }, [
            h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.approve(row, this.approvalTabStatus.READY);
                },
              },
            }, '查看详情'),
          ]),
        },
        {
          title: '状态',
          key: 'workRecordWorkStatus',
          minWidth: 116,
          render: (h, params) => {
            let workstatus = '审批中';
            const workRecordWorkStatus = params.row.workRecordWorkStatus;
            if (workRecordWorkStatus === 1) {
              workstatus = '通过';
            }
            if (workRecordWorkStatus === 2) {
              workstatus = '拒绝';
            }
            if (workRecordWorkStatus === 3) {
              workstatus = '撤回';
            }
            return h('span', workstatus);
          },
        },
        { title: '提交审批人', key: 'workRecordCreateUserName', width: 120 },
      ],
      myColumns: [
        { title: '审批编号', key: 'workRecordWorkNo', minWidth: 280 },
        { title: '审批类型', key: 'workBizTypeName', minWidth: 140 },
        {
          title: '审批名称',
          key: 'workRecordTitle',
          minWidth: 116,
          render: this.hoverRender,
        },
        {
          title: '业务审核内容',
          key: 'workRecordBusinessUrl',
          minWidth: 116,
          render: (h, { row }) => h('div', {
            class: {
              textCenter: true,
            },
          }, [
            h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.approve(row, this.approvalTabStatus.MINE);
                },
              },
            }, '查看详情'),
          ]),
        },
        {
          title: '状态',
          key: 'workRecordWorkStatus',
          minWidth: 116,
          render: (h, params) => {
            let workstatus = '审批中';
            const workRecordWorkStatus = params.row.workRecordWorkStatus;
            if (workRecordWorkStatus === 1) {
              workstatus = '通过';
            }
            if (workRecordWorkStatus === 2) {
              workstatus = '拒绝';
            }
            if (workRecordWorkStatus === 3) {
              workstatus = '撤回';
            }
            return h('span', workstatus);
          },
        },
      ],
      relatedColumns: [
        { title: '审批编号', key: 'workRecordWorkNo', minWidth: 280 },
        { title: '审批类型', key: 'workBizTypeName', minWidth: 140 },
        {
          title: '审批名称',
          key: 'workRecordTitle',
          minWidth: 140,
          render: this.hoverRender,
        },
        { title: '当前节点', key: 'workRecordNode', width: 90 },
        { title: '提交审批人', key: 'workRecordCreateUserName', width: 120 },
        {
          title: '业务审核内容',
          key: 'workRecordBusinessUrl',
          minWidth: 116,
          render: (h, { row }) => h('div', {
            class: {
              textCenter: true,
            },
          }, [
            h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.approve(row, this.approvalTabStatus.RELATED);
                },
              },
            }, '查看详情'),
          ]),
        },
        {
          title: '状态',
          key: 'workRecordWorkStatus',
          minWidth: 116,
          render: (h, params) => {
            let workstatus = '审批中';
            const workRecordWorkStatus = params.row.workRecordWorkStatus;
            if (workRecordWorkStatus === 1) {
              workstatus = '通过';
            }
            if (workRecordWorkStatus === 2) {
              workstatus = '拒绝';
            }
            if (workRecordWorkStatus === 3) {
              workstatus = '撤回';
            }
            return h('span', workstatus);
          },
        },
      ],
    };
  },
  computed: {

    approvalTabStatus() {
      return this.$store.state.publicParams.approvalTabStatus;
    },
    relatedBussinessTypes() {
      return this.$store.state.publicParams.relatedBussinessTypes;
    },
    approvalEndStatus() {
      return this.$store.state.publicParams.approvalEndStatus;
    },
  },
  methods: {
    hoverRender(h, { row }) { // 处理审批名称hover显示，增加提示问文字在hoverList中添加
      return this.hoverList[row.workRecordBusinessType] ? h('lk-tooltip', {
        props: {
          content: this.hoverList[row.workRecordBusinessType], transfer: true,
        },
      }, row.workRecordTitle) : h('span', row.workRecordTitle);
    },
    onTabClick() {
      this.resetPage();
      this.handleSearch();
      if (this.query.endStatus == this.approvalTabStatus.RELATED) {
        this.clear();
      }
    },
    resetPage() {
      this.page = 1;
    },
    clear() {
      this.query.businessType = '';
      this.query.createTime = [];
      this.query.storeIdList = [];
    },
    getData() {
      const params = Object.assign({}, this.query);
      params.page = this.page;
      params.size = this.size;
      const endStatus = this.query.endStatus;
      let fetchFunc = workflow.worklist;
      if (endStatus == this.approvalTabStatus.MINE) {
        fetchFunc = workflow.myWorklist;
        delete params.endStatus;
      }
      if (endStatus == this.approvalTabStatus.RELATED) {
        fetchFunc = workflow.relatedWorklist;
        params.createTimeBegin = params.createTime && params.createTime[0];
        params.createTimeEnd = params.createTime && params.createTime[1];
        delete params.createTime;
        delete params.endStatus;
      }
      fetchFunc(params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          if (res.data.data && res.data.data.list) {
            this.count = res.data.data.count;
            res.data.data.list.forEach((item) => {
              const result = {};
              utils.exchangeTable(item, result);
              console.log(result);
              this.tableData.push(result);
            });
          }
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getBussinessTypes() {
      workflow.bussinessTypes().then((res) => {
        if (res.data.status === 200) {
          this.bussinessTypes = [];
          this.bussinessTypes = res.data.data;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    approve(row, approvalTabStatus) {
      const {
        workRecordId, workRecordNode, workRecordWorkNo, workRecordBusinessUrl, workRecordBusinessId, workRecordBusinessType, workRecordEndStatus,
      } = row;
      this.$router.push(
        {
          name: 'approvalEdit',
          params: {
            id: encodeURIComponent(workRecordId),
            node: workRecordNode,
            workNo: encodeURIComponent(workRecordWorkNo),
            businessUrl: encodeURIComponent(workRecordBusinessUrl),
            businessId: encodeURIComponent(workRecordBusinessId),
            businessType: encodeURIComponent(workRecordBusinessType),
            endStatus: encodeURIComponent(workRecordEndStatus),
            approvalTabStatus,
          },
        },
      );
    },
    showExportModal() {
      this.modalVisiable = true;
      this.exportQuery = {
        workExportType: null,
      };
    },
    async exportData(e) {
      const exportValidate = await this.$refs.export.validate();
      const target = e.target;
      const downloadCart = this.$root.$children[0].$children[0].$refs.downloadCart; // 导出购物车的位置
      if (!exportValidate) return;
      const params = utils.deepClone(this.exportQuery);
      if (this.exportQuery.createTime && this.exportQuery.createTime.length) {
        params.createTimeBegin = params.createTime[0];
        params.createTimeEnd = params.createTime[1];
        delete params.createTime;
      }
      params.queryCondition = utils.getQueryCondition('.exportQueryContainer');
      workflow.exportWorkRecord(params).then((res) => {
        if (res.data.status !== 200) {
          this.$Message.error(res.data.error);
          return;
        }
        downloadCart.drop(target);
        this.modalVisiable = false;
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    cancelModal() {
      this.modalVisiable = false;
    },
  },
  mounted() {
    this.handleSearch(true);
    this.getBussinessTypes();
    this.$store.state.user.roles.some((item) => {
      if (item.id === 10) {
        this.showRelated = true;
        return true;
      }
    });
  },
  created() {
    if (this.roleType !== 2) {
      this.waitColumns.splice(0, 0, { title: '门店名称', key: 'workRecordStoreName', minWidth: 116 });
      this.finishColumns.splice(0, 0, { title: '门店名称', key: 'workRecordStoreName', minWidth: 116 });
      this.myColumns.splice(0, 0, { title: '门店名称', key: 'workRecordStoreName', minWidth: 116 });
      this.relatedColumns.splice(0, 0, { title: '门店名称', key: 'workRecordStoreName', minWidth: 116 });
    }
  },
};
</script>
<style lang="less" scoped>
  .queryContainer{
    display: flex;
    padding-bottom: 16px;
    flex-wrap: wrap;
    .queryItem{
      display: flex;
      align-items: center;
      margin-right: 32px;
      flex-wrap: wrap;
      margin-bottom: 15px;
      .item{
        display: inline-block;
        width: 256px
      }
    }
  }
  .export-btn {
    position: absolute;
    right: 16px;
    top:  5px;
    z-index: 999;
  }
  .export-query {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .item {
        width: 250px;
    }
  }
</style>
